module.exports = __webpack_public_path__ + "static/media/hiddenObjects_icon--active.e79d8f78.svg";